module.exports = __webpack_public_path__ + "img/img_bagsize_withbelt.b070af5f.png";